<template>
  <div id="app" :class="{ 'd-none': skipDatepicker }">
    <div class="progressbar">
      <ul>
        <li :class="{ active: currentStep == 0 }">
          <a href="#" @click.prevent="jumpToStep(0)"> 1. Select surf camp </a>
        </li>
        <li :class="{ active: currentStep == 1 }">
          <a v-if="currentStep > 1" @click.prevent="jumpToStep(1)" href="#">
            2. Select date
          </a>
          <span v-else>2. Select date </span>
        </li>
        <li :class="{ active: currentStep == 2 }">
          <a v-if="currentStep > 2" href="#" @click.prevent="jumpToStep(2)">
            3. Enter data 
          </a>
          <span v-else>3. Enter data</span>
        </li>
        <li :class="{ active: currentStep == 3 }">
          <a v-if="currentStep > 3" href="#"> 4. Complete booking </a>
          <span v-else>4. Complete booking</span>
        </li>
      </ul>
    </div>
    <div
      style="max-width: 960px; margin-bottom: 100px"
      v-if="urlBuild === false"
    >
      <!-- 1. Länderübersicht -->
      <div v-if="!campSelected" class="country">
        <h3>Please select a surf camp:</h3>
        <div
          class="country--item"
          v-for="(country, index) in countryList"
          :key="index"
        >
          <button @click="collapse" type="button" class="collapsible">
            {{ country.title }}
          </button>
          <div class="content">
            <ul class="camp--list">
              <li
                class="camp--item"
                v-for="(camp, index) in country.camps"
                :key="index"
              >
                {{ camp.title }}

                <!-- 1.1 Camps ohne Ratio durchbuchbarkeit -->
                <a
                  v-if="camp.link !== undefined"
                  :href="camp.link"
                  class="btn btn-cta wr"
                >
                  Book now!</a
                >
                <!-- 1.2 Camps mit mehreren Reisecodes z.B. Buscamps  -->
                <a
                  v-else-if="camp.campCodes.length == 1"
                  href="#"
                  @click.prevent="
                    setData(
                      country.title,
                      camp.title,
                      camp.campCodes[0],
                      true,
                      camp.catalogCode
                    )
                  "
                  class="btn btn-cta mr"
                  >Book now!</a
                >
                <!-- 1.3 Alles andere  -->
                <a
                  v-else
                  @click.prevent="
                    listCampCodes(
                      country.title,
                      camp.title,
                      camp.campCodes,
                      camp.catalogCode
                    )
                  "
                  href="#"
                  class="btn btn-cta or"
                  >JBook now!</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else class="country--item">
        <h2>{{ countryTitle }}</h2>
        <h3>{{ campCodesTitle }}</h3>
        <div class="content" style="display: block">
          <!-- 2. Datepicker, wenn es nur noch ein Reisecode gibt -->
          <div v-if="!multipleCampCodes" class="card">
            <div v-if="hint" class="hint">
              {{ hint }}
            </div>

            <p class="card--head">Please select a date:</p>
            <div class="datepicker">
              <div>
                <label>From:</label><br />
                <datepicker
                  v-model="state.startDate"
                  :highlighted="state.highlighted"
                  :disabled-dates="state.disabledDates"
                  :language="de"
                  :monday-first="true"
                  :open-date="state.datepickerOpenDate"
                  :maximum-view="'day'"
                  :required="true"
                  @input="calculateEndDate(state.startDate)"
                ></datepicker>
              </div>

              <div v-if="weekly">
                <label>Duration of your stay:</label><br />
                <select
                  :disabled="state.startDate ? false : true"
                  v-model="duration"
                  @change="calculateEndDate(state.startDate)"
                >
                  <option value="1" selected>1 week</option>
                  <option value="2">2 weeks</option>
                </select>
              </div>

              <div>
                <label>Till:</label><br />
                <datepicker
                  v-model="state.endDate"
                  :open-date="new Date(state.startDate)"
                  :highlighted="state.highlighted"
                  :disabled-dates="state.disabledEndDates"
                  :disabled="state.disabledEndDateInput"
                  :language="de"
                  :required="true"
                  :monday-first="true"
                ></datepicker>
              </div>
              <div class="btn-wrapper">
                <button
                  class="btn"
                  v-bind:class="{ active: dateSelected }"
                  @click="
                    buildUrl(
                      campCode,
                      state.startDate,
                      state.endDate,
                      catalogCode
                    )
                  "
                  target="_self"
                >
                  Book now
                </button>
              </div>
            </div>
          </div>
          <!-- Hausart (Bsp. SLP) -->
          <div
            v-else-if="
              multipleCampCodes &&
              !isBusCamp(campCodes[0]) &&
              !isBusCamp(campCodes[1])
            "
            class="card"
          >
            <p class="card--head">Which option do you prefer?:</p>
            <ul class="camp--list">
              <li
                class="camp--item"
                v-for="(campCode, index) in campCodes"
                :key="index"
              >
                <span>{{ json[campCode].title }}</span>
                <a
                  href="#"
                  @click.prevent="
                    setData(
                      countryTitle,
                      campCodesTitle,
                      campCode,
                      true,
                      catalogCode
                    )
                  "
                  class="btn btn-cta"
                  >Select date</a
                >
              </li>
            </ul>
          </div>
          <!-- Anreiseart -->
          <div v-else class="card">
            <p class="card--head">How would you like to travel:</p>
            <ul class="camp--list">
              <li
                class="camp--item"
                v-for="(campCode, index) in campCodes"
                :key="index"
              >
                <span v-if="isBusCamp(campCode)">Bus</span>
                <span v-else>Individual arrival</span>
                <a
                  href="#"
                  @click.prevent="
                    setData(
                      countryTitle,
                      campCodesTitle,
                      campCode,
                      true,
                      catalogCode
                    )
                  "
                  class="btn btn-cta"
                  >Select date</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 3. IFRAME -->
    <div v-else>
      <iframe
        v-resize="{ log: false }"
        style="
          max-width: 100%;
          max-height: 100%;
          min-height: 800px;
          width: 1440px;
          overflow: hidden;
        "
        :src="urlBuild"
        id="booking-iframe"
        frameborder="0"
        scrolling="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import json from "./data.json";
import Datepicker from "@sum.cumo/vue-datepicker";
import { de } from "@sum.cumo/vue-datepicker/dist/locale";
import iframeResize from "iframe-resizer/js/iframeResizer";
import "@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css";

export default {
  components: {
    Datepicker,
  },
  directives: {
    resize: {
      bind: function (el, { value = {} }) {
        el.addEventListener("load", () => iframeResize(value, el));
      },
    },
  },
  data() {
    return {
      // Progressbar
      currentStep: 0,

      // Datepicker
      skipDatepicker: false,
      campSelected: false,
      multipleCampCodes: false,
      countryTitle: "",
      campCodesTitle: "",
      campCodes: [],
      catalogCode: "",
      hint: "",
      dateSelected: false,
      urlBuild: false,
      countryList: [
        {
          title: "France",
          camps: [
            {
              title: "24+ Surf Camp Moliets",
              campCodes: ["EAUMOL"],
              catalogCode: "PURE23",
            },
            {
              title: "Premium Surf Lodge Hossegor",
              campCodes: ["SLF"],
              catalogCode: "PURE23",
            },
            {
              title: "Surf Camp Seignosse",
              campCodes: ["EAEST"],
              catalogCode: "PURE23",
            },
            {
              title: "Family Surf Camp Biscarrosse",
              campCodes: ["EAFBIS"],
              catalogCode: "PURE23",
            },
          ],
        },
        {
          title: "Morocco",
          camps: [
            {
              title: "Sea View Surf Camp Morocco",
              campCodes: ["MSV"],
              catalogCode: "PURE23",
            },
            {
              title: "Pure Surf Camp Morocco",
              campCodes: ["MAR"],
              catalogCode: "PURE23",
            },
          ],
        },
        {
          title: "Portugal",
          camps: [
            {
              title: "Beachfront Surf Camp Caparica",
              campCodes: ["CAPA"],
              catalogCode: "PURE23",
            },
            {
              title: "Eco Surf Lodge Caparica",
              campCodes: ["ECOCAPA"],
              catalogCode: "PURE23",
            },
            {
              title: "Surf House Caparica",
              campCodes: ["CSH"],
              catalogCode: "PURE23",
            },
            {
              title: "Sunset Surf Lodge Ericeira",
              campCodes: ["SSLE"],
              catalogCode: "PURE23",
            },
            {
              title: "Surf Villa Ericeira",
              campCodes: ["SVERIC"],
              catalogCode: "PURE23",
            },
            {
              title: "Surf Camp Peniche",
              campCodes: ["PEN"],
              catalogCode: "PURE23",
            },
            {
              title: "Surf Lodge Portugal",
              campCodes: ["SLI"],
              catalogCode: "PURE23",
            },
            {
              title: "Surf Camp Algarve",
              campCodes: ["SCA"],
              catalogCode: "PURE23",
            },
            {
              title: "Surflodge Santa Cruz",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=414&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "Spain",
          camps: [
            {
              title: "Surf Camp Oyambre",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=1576&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf Camp Zarautz",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=836&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf House Galicia",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=272&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "Canaries",
          camps: [
            {
              title: "Surf Camp Gran Canaria",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=1926&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf Villa Fuerte",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=1415&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf Camp Fuerteventura",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=271&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf Camp Tenerife",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=266&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },

        {
          title: "Sri Lanka",
          camps: [
            {
              title: "Surf House Sri Lanka",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=331&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf & Yoga Sri Lanka",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=555&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "Indonesia",
          camps: [
            {
              title: "Surf Camp Bali Bukit",
              campCodes: [],
              link: "https://www.puresurfcamps.com/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=407&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf Camp Bali Padang",
              campCodes: [],
              link: "https://www.puresurfcamps.com/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=277&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "Costa Rica",
          camps: [
            {
              title: "Surf Camp Costa Rica",
              campCodes: [],
              link: "https://www.puresurfcamps.com/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=269&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf House Costa Rica",
              campCodes: [],
              link: "https://www.puresurfcamps.com/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=270&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
            {
              title: "Surf Lodge Costa Rica",
              campCodes: [],
              link: "https://www.puresurfcamps.com/buchung/?tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5BcampUid%5D=1574&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "Nicaragua",
          camps: [
            {
              title: "Surf Camp Nicaragua",
              campCodes: [],
              link: "https://www.puresurfcamps.com/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=547&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "South Africa",
          camps: [
            {
              title: "Surf Lodge South Africa",
              campCodes: ["JEFF"],
              link: "/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=261&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "Caribbean",
          camps: [
            {
              title: "Surf Camp Caribbean",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=308&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
        {
          title: "Maldives",
          camps: [
            {
              title: "Surf Resort Maldives",
              campCodes: [],
              link: "/buchung/?tx_puresurfcamps_booking%5BcampUid%5D=264&tx_puresurfcamps_booking%5Baction%5D=displayBookingForm&tx_puresurfcamps_booking%5Bcontroller%5D=Booking",
            },
          ],
        },
      ],
      json: json,
      title: "",
      weekly: false,
      duration: "1",
      busCamp: false,
      campCode: "",
      de,
      datepickerOpenDate: "",
      state: {
        startDate: "",
        endDate: "",
        disabledEndDateInput: true,
        highlighted: {
          from: new Date("2021-03-06"),
          to: new Date("2021-06-25"),
          days: [],
          includeDisabled: false,
        },
        disabledDates: {
          campCode: "",
          from: "",
          to: "",
          days: [],
          ranges: [],
          customPredictor: function (d) {
            if (json[this.campCode].seasonalCamp !== undefined) {
              const season = json[this.campCode].seasonalCamp;
              d.setHours(d.getHours() + 2);

              if (Array.isArray(season)) {
                for (let i = 0; i < season.length; i++) {
                  let dateIsHighSeason =
                    d >= new Date(season[i].from) &&
                    d <= new Date(season[i].to);
                  if (dateIsHighSeason && d.getDay() != 6) {
                    return true;
                  }
                }
              } else {
                let dateIsHighSeason =
                  d >= new Date(season.from) && d <= new Date(season.to);
                if (dateIsHighSeason && d.getDay() != 6) {
                  return true;
                }
              }
            }
          },
        },
        disabledEndDates: {
          to: "",
        },
      },
    };
  },
  beforeCreate() {
    this.campCode = this.$route.query.campcode;
  },
  mounted() {
    this.init();
  },

  methods: {
    jumpToStep(step) {
      if (step === 0) {
        this.campCodesTitle = "";
        this.countryTitle = "";
        this.campCode = "";
        this.campCodes = "";
        this.title = "";
        this.campSelected = false;
        this.currentStep = 0;
        this.state.startDate = "";
        this.state.endDate = "";
        this.catalogCode = "";
      }

      if (step === 1) {
        this.currentStep = 1;
      }

      this.urlBuild = false;
      this.state.startDate = "";
      this.state.endDate = "";

      return step;
    },

    collapse(event) {
      let coll = document.getElementsByClassName("collapsible");
      let i;
      for (i = 0; i < coll.length; i++) {
        coll[i].classList.remove("active");
        var content = coll[i].nextElementSibling;
        if (content.style.display === "block") {
          content.style.display = "none";
        }
      }

      event.target.classList.toggle("active");
      var c = event.target.nextElementSibling;
      if (c.style.display === "block") {
        c.style.display = "none";
      } else {
        c.style.display = "block";
      }
    },

    init() {
      let queryArg = this.$route.query;

      let reiseCode = undefined;
      if (queryArg["tx_puresurfcamps_booking[rc]"] !== undefined) {
        reiseCode = queryArg["tx_puresurfcamps_booking[rc]"];
      }

      if (queryArg["katalogreisecode"] !== undefined) {
        reiseCode = queryArg["katalogreisecode"];
      }

      let katalogCode = undefined;
      if (queryArg["tx_puresurfcamps_booking[kc]"] !== undefined) {
        katalogCode = queryArg["tx_puresurfcamps_booking[kc]"];
      }

      if (queryArg["katalogcode"] !== undefined) {
        katalogCode = queryArg["katalogcode"];
      }

      if (
        queryArg["tx_puresurfcamps_booking[campUid]"] !== undefined &&
        reiseCode === undefined
      ) {
        this.skipDatepicker = true;
        document.querySelector(".form--bf__outer").style.display = "flex";
        return;
      }

      if (reiseCode !== undefined) {
        this.campCode = reiseCode;

        if (katalogCode !== undefined) {
          this.catalogCode = katalogCode;
        }

        if (this.campCode.includes(",")) {
          let campCodes = this.campCode.split(",");
          this.title = json[campCodes[0]].title;
          let country = json[campCodes[0]].country;
          this.listCampCodes(country, this.title, campCodes, this.catalogCode);
        } else {
          this.getJsonData();
        }

        if (queryArg["von"] !== undefined) {
          let dmy = queryArg["von"].split(".");
          let von = `${dmy[1]}.${dmy[0]}.${dmy[2]}`;
          this.state.startDate = von;

          this.calculateEndDate(von);
        }
      }
    },

    getJsonData() {
      let campCode = this.campCode;
      let country = json[campCode].country;
      this.busCamp = json[campCode].busCamp;
      this.weekly = json[campCode].weekly;

      if (campCode !== undefined) {
        this.setData(country, this.title, campCode, false, this.catalogCode);
      }

      this.state.disabledDates.to = new Date();

      //if (json[campCode].datepickerOpenDate > )
      let currentDate = new Date();
      this.state.datepickerOpenDate = new Date().toISOString().slice(0, 10);
      let jsonDate = json[campCode].datepickerOpenDate;
      if (jsonDate) {
        if (new Date(jsonDate) > currentDate) {
          this.state.datepickerOpenDate = new Date(jsonDate);
        }
      }

      if (json[campCode].highlighted.days !== undefined) {
        this.state.highlighted.days = json[campCode].highlighted.days;
      }

      if (json[campCode].disabled.to !== undefined) {
        this.state.disabledDates.to = new Date(json[campCode].disabled.to);
      }

      if (json[campCode].disabled.from !== undefined) {
        this.state.disabledDates.from = new Date(json[campCode].disabled.from);
      }

      if (json[campCode].disabled.days !== undefined) {
        this.state.disabledDates.days = json[campCode].disabled.days;
      }

      this.state.disabledDates.ranges = [];
      if (json[campCode].disabled.ranges !== undefined) {
        let dRanges = json[campCode].disabled.ranges;

        for (let i = 0; i < dRanges.length; i++) {
          const dr = dRanges[i];
          this.state.disabledDates.ranges.push({
            from: new Date(dr.from),
            to: new Date(dr.to),
          });
        }
      }
    },

    calculateEndDate(startDate) {
      if (this.state.startDate === undefined) {
        this.state.startDate = startDate;
      }

      var d = new Date(this.state.startDate);
      let dateIsHighSeason = false;

      // min end date
      this.state.disabledEndDates.to = this.addDaysToDate(this.state.startDate, 5);

      // max end date
      this.state.disabledEndDates.from = this.addDaysToDate(this.state.startDate, 14);

      // max days between hs and flex
      

      if(Array.isArray(json[this.campCode].disabled.ranges)) {
        const lastFlexDays = 10;
        let ranges = json[this.campCode].disabled.ranges;
        for (let i = 0; i < ranges.length; i++) {
          let currentEndDateFrom = new Date(ranges[i].from + ' 00:00');
          const dateDifference = Math.abs(Math.floor((d - new Date(ranges[i].from + ' 00:00')) / (1000*60*60*24)));

          // wenn flex und unter 10 tagen
          if (d < currentEndDateFrom && dateDifference <= lastFlexDays) {
            this.state.disabledEndDates.from = this.addDaysToDate(ranges[i].from, 5);
          }

          // wenn gleiches date wie disable
          if (startDate.toDateString() == new Date(ranges[i].from + ' 00:00').toDateString()) {
            this.state.disabledEndDates.from = this.state.disabledEndDates.to;
          }
        }
      }

      if (json[this.campCode].seasonalCamp !== undefined) {
        const season = json[this.campCode].seasonalCamp;
        let dateIsHighSeason = false;

        if (Array.isArray(season)) {
          const lastFlexDays = 13;
          for (let i = 0; i < season.length; i++) {
            const currentDate = this.addDaysToDate(d, 7);
            const seasonStartDate = new Date(season[i].from);
            const dateDifference = Math.abs(Math.floor((d - new Date(season[i].from + ' 00:00')) / (1000*60*60*24)));

            // wenn flex und unter 10 tagen
            if (d < new Date(season[i].from) && dateDifference <= lastFlexDays) {
              this.state.disabledEndDates.from = seasonStartDate;
            }

            // if chosen date is in flex to high range
            if (currentDate.toDateString() === seasonStartDate.toDateString()) {
              this.state.disabledEndDates.from = currentDate;
            }

            dateIsHighSeason = this.isDateInHighSeason(
              d,
              season[i].from,
              season[i].to
            );
            if (dateIsHighSeason === true) {
              break;
            }
          }
        } else {
          dateIsHighSeason = this.isDateInHighSeason(d, season.from, season.to);
        }

        // Saison Ende
        let lastDateHighSeason = new Date(
          new Date(season.to).setDate(new Date(season.to).getDate() + 1)
        );

        let isLastDate = this.isDateInHighSeason(
          d,
          season.from,
          lastDateHighSeason
        );

        if (isLastDate) {
          this.state.disabledEndDates.to = new Date(
            new Date(startDate).setDate(startDate.getDate() + 7)
          );
        }

        if (dateIsHighSeason) {
          this.weekly = true;
        } else {
          this.weekly = false;
        }
      }

      if (dateIsHighSeason || this.weekly) {
        this.state.disabledEndDateInput = true;
        let weekDays = 7;
        if (this.busCamp === true) {
          weekDays = 9;
        }
        if (parseInt(this.duration) === 2) {
          weekDays = 14;
          if (this.busCamp === true) {
            weekDays = 16;
          }
        }

        d.setDate(new Date(this.state.startDate).getDate() + weekDays);

        this.state.endDate = d;
        this.dateSelected = true;
      } else {
        this.state.disabledEndDateInput = false;
        this.weekly = false;
      }
    },

    addDaysToDate(date, days) {
      return new Date(
        new Date(date).setDate(
          new Date(date).getDate() + days
        )
      );
    },

    substractDaysOfDate(date, days) {
      return new Date(
        new Date(date).setDate(
          new Date(date).getDate() - days
        )
      );
    },

    isDateInHighSeason(date, from, to) {
      date.setHours(date.getHours() + 2);
      return date >= new Date(from) && date <= new Date(to);
    },

    listCampCodes(countryTitle, campCodesTitle, campCodes, catalogCode = "") {
      this.countryTitle = countryTitle;
      this.campCodesTitle = campCodesTitle;
      this.multipleCampCodes = true;
      this.campCodes = campCodes;
      this.campSelected = true;
      if (catalogCode !== "") {
        this.catalogCode = catalogCode;
      }
    },

    isBusCamp(campCode) {
      return json[campCode].busCamp;
    },

    setData(
      countryTitle,
      campTitle,
      campCode,
      getJsonData = false,
      catalogCode = ""
    ) {
      if (catalogCode !== "") {
        this.catalogCode = catalogCode;
      }

      this.campCodesTitle = campTitle;
      this.countryTitle = countryTitle;
      this.campCode = campCode;
      this.state.disabledDates.campCode = campCode;
      this.campSelected = true;
      this.multipleCampCodes = false;
      this.currentStep = 1;

      if (getJsonData) {
        this.getJsonData();
      }
    },

    buildUrl(campCode, from, to, catalogCode = "") {
      this.currentStep = 2;

      const ratioUrl = new URL(
        "https://www.ratioapp.de/webplattform/apps/webbuchung/puresurfcamps?lang=en"
      );

      let fromString = "";
      let toString = "";

      if (from !== undefined && to !== undefined) {
        from = new Date(from);
        to = new Date(to);

        fromString = `${from.getDate()}.${
          from.getMonth() + 1
        }.${from.getFullYear()}`;
        toString = `${to.getDate()}.${to.getMonth() + 1}.${to.getFullYear()}`;

        ratioUrl.searchParams.append("von", fromString);
        ratioUrl.searchParams.append("bis", toString);
      }

      if (catalogCode == "") {
        catalogCode = "PURE23";
      }
      ratioUrl.searchParams.append("katalogcode", catalogCode);
      ratioUrl.searchParams.append("katalogreisecode", campCode);

      this.urlBuild = ratioUrl;

      return ratioUrl;
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: "Lato", sans-serif;
  color: #3a3a3a;
}

.form--bf__outer,
.lstbc__wrapper {
  display: none;
}

#app {
  width: 1440px;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  iframe {
    min-height: 480px;
  }

  &.d-none {
    display: none;
  }

  label {
    font-size: 16px;
    color: #3a3a3a;
    font-weight: bold;
    margin-bottom: 8px;
    display: inline-block;
  }

  h2 {
    font-size: 40px;
  }

  h3 {
    font-size: 32px;
  }

  h4 {
    font-size: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    margin: 0;
    padding: 20px 20px;
  }
  input {
    padding: 10px 15px;
  }

  .hint {
    padding: 15px;
    border: #e74c3c 1px solid;
  }

  .btn {
    text-decoration: none;
    float: right;
    background: linear-gradient(90deg, #eec871 0%, #ddae42 100%);
    color: #3a3a3a;
    font-weight: bold;
    padding: 12px 16px;
    border-radius: 6px;
    border: 1px solid #fff;
    margin-top: -12px;
    letter-spacing: normal;
    font-size: 14px;

    @media screen and (min-width: 64em) {
      font-size: 16px;
      padding: 12px 16px;
    }
  }

  /* Style the button that is used to open and close the collapsible content */
  .collapsible {
    background-color: #f7fbfb;
    color: #3a3a3a;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    border: none;
    font-weight: bold;
    text-align: left;
    outline: none;
    font-size: 15px;
  }

  /* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
  .active,
  .collapsible:hover {
    background: linear-gradient(90deg, #eec871 0%, #ddae42 100%);
    color: #3a3a3a;
  }

  /* Style the collapsible content. Note: hidden by default */
  .content {
    display: none;
    background-color: #fff;
    border-radius: 4px;
  }

  select {
    font-size: 16px;
    height: 40px;
    width: 150px;
    padding: 0 10px;
    text-align: center;
  }

  .datepicker {
    display: flex;
    justify-content: flex-start;
    padding: 20px;
    flex-direction: column;

    @media screen and (min-width: 64em) {
      flex-direction: row;
    }

    > div {
      margin-bottom: 20px;

      @media screen and (min-width: 64em) {
        margin-right: 20px;
      }

      input,
      select {
        width: 100%;
      }

      &.btn-wrapper {
        float: none;
        margin-top: 12px;

        @media screen and (min-width: 64em) {
          float: right;
          margin-top: -12px;
          text-align: right;
          align-self: flex-end;
          flex-grow: 1;
        }
      }
    }

    .btn {
      cursor: pointer;
      width: 100%;
      @media screen and (min-width: 64em) {
        width: inherit;
      }
    }
  }

  .card {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

    &--head {
      background: #3a3a3a;
      color: white;
      padding: 20px;
      margin: 0;
      font-weight: bold;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  .camp {
    &--list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &--item {
      font-size: 14px;
      padding: 20px 20px;
      color: #3a3a3a;

      @media screen and (min-width: 64em) {
        font-size: 16px;
      }

      &:hover {
        background: rgba(238, 200, 113, 0.2);
      }
    }
  }

  .progressbar {
    display: inline-block;
    margin-bottom: 20px;
    width: 100%;
    max-width: 1440px;
    position: relative;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        background: rgba(0, 0, 0, 0.2);
        height: 4px;
        width: 100%;
        bottom: -4px;
      }

      li {
        position: relative;
        float: left;
        padding: 10px 15px;

        &.active {
          a,
          span {
            color: #3a3a3a;
            font-weight: bold;
            text-decoration: none;
          }

          &::after {
            content: "";
            position: absolute;
            left: 0;
            background: linear-gradient(90deg, #eec871 0%, #ddae42 100%);
            height: 4px;
            width: 100%;
            bottom: -4px;
          }
        }
      }
    }
  }
}
</style>
